// Display precision only; untouched values retain calculation precision.
export function allocationPercent(fraction) {
  return Number((Number(fraction) * 100).toFixed(2));
}
